// extracted by css-extract-rspack-plugin
var _1 = "gPrsM-prpDtevHq3SCqtTw--";
export { _1 as "headingDaysRemaining" }
